import { Axios } from '@/config/axios'
import axios from 'axios'

const state = {
}

const getters = {
}

const actions = {
    getAgents ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/agents?page=${data.page}&perPage=${data.perPage}&ohpEuid=${data.adminOhpEuid}`).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },
    getAgentsUninstallToken ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/get-agents-uninstall-token?page=${data.page}&perPage=${data.perPage}&ohpEuid=${data.adminOhpEuid}`).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },
    downloadAgent ({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios({
                url: `${process.env.VUE_APP_API_URL}/download/agent?os=${data.os}`,
                method: 'GET',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                responseType: 'blob', // important for download
                data: data
            }).then((response) => {
                resolve(response)
            })
            .catch(function (error) {
                reject(error)
            })
        })
    }
}

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
